export const VIDEO_EXERCISE = 'VideoExercise';
export const EXPORTED_EXERCISES = [VIDEO_EXERCISE];